import React from 'react';
import styled from 'styled-components';

import { P } from '../../styles/typography';
import { mediaMin, mediaMax } from '@styles/sizes';
import { GridRow } from '../../styles/grid';

import Layout from '../../components/layout';
import SEO from '../../components/seo';
import Container from '../../components/Container/Container';
import { Wrapper } from '../../components/Container/Wrapper';
import Image from '../../components/Image/Image';
import Video from '../../components/Video/Video';
import Title from '../../components/Template/Title';
import PageTransition from '../../components/pageTransition';

import Video_Film from '../../videos/film.mp4';


const StyledFilmVideo = styled(Video)`
  width: 100%;
  margin: 0 auto;
`;

const StyledFilmContent = styled(GridRow)`
  max-width: 800px;
  flex-direction: column;
`;

const StyledBgGreen = styled.div`
  background: #f1f5f2;
  padding: 80px;
  ${mediaMax.tablet`
    padding: 40px;
`}
  ${mediaMax.phone`
    padding: 24px;
`}
`;

const StyledProjectWrapper = styled.div`
  margin-bottom: 80px;
`;

const StyledProjectIntroWrapper = styled.div`
  ${mediaMin.tablet`
    width: 45%;
    max-width: 450px;
    margin-left: auto;
`}
`;

const StyledProjectRow = styled.div`
  display: flex;
  margin-bottom: 40px;
  ${mediaMax.tablet`
    flex-direction: column;
`}
`;

const StyledProjectIntro = styled.div`
  margin-bottom: 40px;
`;

const StyledProjectImage1 = styled(Image)`
  max-width: 400px;
  ${mediaMax.tablet`
    display: none;
`}
`;

const FilmPage = () => (
  <Layout>
    <SEO title="Film." />
    <PageTransition>
      <Wrapper>
        <Title>Film.</Title>
        <Container small>
          <StyledProjectWrapper>
            <StyledProjectRow>
              <StyledProjectImage1
                src={'mobile-setup.jpg'}
                caption={'Editing suite - safari style'}
              />
              <StyledProjectIntroWrapper>
                <StyledProjectIntro>
                  <h3>
                    Why Choose
                    <br /> Reel Nature
                  </h3>
                  <P>
                    Reel Nature offers complete solutions for all sorts of
                    filming requirements, but what sets us apart is our
                    appreciation of how valuable time is in this industry and
                    our ability to ensure that teams maximize their time in the
                    field by utilising our own equipment and personnel (less
                    need for 3rd parties).
                  </P>
                </StyledProjectIntro>
                <Image src={'camera-arm.jpg'} caption={'Tracking camera'} />
              </StyledProjectIntroWrapper>
            </StyledProjectRow>
            <StyledProjectRow>
              <Image
                src={'on-location.jpg'}
                maxWidth={800}
                caption={'The team on Location'}
              />
            </StyledProjectRow>
          </StyledProjectWrapper>
        </Container>
        <StyledBgGreen>
          <Container small>
            <StyledFilmContent>
              <h3>Reel Set Up</h3>
              <P>
                Our bespoke filming rigs and mobile camps can fully cater for
                crew-members in the remotest of locations with every detail
                taken care of, from comfortable and safe tented accommodation to
                24/7 power supply and cooling fans for computers and editing
                equipment in our mobile editing/data suite.
              </P>

              <P>
                Reel Nature’s setup allows crews to be in the field for extended
                periods of time without having to worry about returning to a
                base for charging/feeding/sleeping, saving precious filming time
                and making every second count.
              </P>

              <P>
                Our set-up also allows unprecedented access to some of the more
                challenging filming locations in the region where accommodation
                and support may be hard to come by and where more static
                organisations may not have the capacity to host film crews.
              </P>
              <StyledFilmVideo
                src={Video_Film}
              />
            </StyledFilmContent>
          </Container>
        </StyledBgGreen>
      </Wrapper>
    </PageTransition>
  </Layout>
);

export default FilmPage;
